// // import React, { useEffect, useState } from 'react';
// // import {
// //   Container,
// //   TextField,
// //   Button,
// //   Box,
// //   Typography,
// //   Paper,
// //   IconButton,
// //   Select,
// //   MenuItem,
// // } from '@mui/material';
// // import { MdCameraAlt } from 'react-icons/md';
// // import { FaImage } from 'react-icons/fa6';
// // import { isEmpty, map } from 'lodash';
// // import itemService from '../../services/itemService';
// // import departmentService from '../../services/departmentService';

// // const AllotedItemForm = () => {
// //   // const [boxes, setBoxes] = useState({
// //   //   '250ml': '',
// //   //   '500ml': '',
// //   //   '1L': '',
// //   //   '5L': '',
// //   //   '20L': '',
// //   //   '300ml': '',
// //   // });
// //   const [selectedFile, setSelectedFile] = useState(null);
// //   const [departments, setDepartments] = useState([]);
// //   const [selectedDepartment, setSelectedDepartment] = useState('');
// //   const [items, setItems] = useState([])

// //   // const handleChange = (size, value) => {
// //   //   setBoxes({
// //   //     ...boxes,
// //   //     [size]: value,
// //   //   });
// //   // };

// //   const handleFileChange = (event) => {
// //     if (event.target.files.length > 0) {
// //       setSelectedFile(event.target.files[0]);
// //     }
// //   };

// //   const handleSubmit = () => {
// //     // console.log('Submitted data: ', boxes);
// //     console.log('Uploaded file: ', selectedFile);
// //   };

// //   const handleDiscard = () => {
// //     // setBoxes({
// //     //   '250ml': '',
// //     //   '500ml': '',
// //     //   '1L': '',
// //     //   '5L': '',
// //     //   '20L': '',
// //     //   '300ml': '',
// //     // });
// //     setSelectedFile(null);
// //   };

// //   const fetchDepartment = async () => {
// //     const response = await departmentService.getDepartments();
// //     setDepartments(response.data);
// //   };

// //   const fetchItem = async () => {
// //     const response = await itemService?.getItems();
// //     setItems(response.data);
// //   };

// //   useEffect(() => {
// //     fetchDepartment();
// //     fetchItem();
// //   }, []);

// //   console.log('items', items, departments);

// //   return (
// //     <Container maxWidth='sm'>
// //       <Paper elevation={3} style={{ padding: '20px', marginTop: '20px' }}>
// //         <Box display='flex' alignItems='center' justifyContent='space-between'>
// //           <Typography variant='h5'>OUTWARD WATER</Typography>
// //         </Box>

// //         <Box component='form' sx={{ mt: 2 }}>
// //           <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.6 }}>
// //             <div style={{ fontWeight: 500, fontSize: '0.8rem' }}>
// //               {' '}
// //               Select Department
// //             </div>
// //             <Select
// //               name='department_id'
// //               value={selectedDepartment}
// //               fullWidth
// //               onChange={(e) => setSelectedDepartment(e?.target?.value)}
// //             >
// //               {!isEmpty(departments) ? (
// //                 map(departments, (option) => (
// //                   <MenuItem key={option?.id} value={option?.id}>
// //                     {option?.name}
// //                   </MenuItem>
// //                 ))
// //               ) : (
// //                 <MenuItem>No data found</MenuItem>
// //               )}
// //             </Select>
// //             {selectedDepartment && (
// //               <div style={{ color: 'red', fontSize: '0.7rem' }}>
// //                 Department is required
// //               </div>
// //             )}
// //           </Box>
// //           {/* {selectedDepartment &&
// //             Object.keys(boxes).map((size) => (
// //               <Box
// //                 key={size}
// //                 display='flex'
// //                 alignItems='center'
// //                 justifyContent='space-between'
// //                 sx={{ mb: 2 }}
// //               >
// //                 <Typography>{size}</Typography>
// //                 <TextField
// //                   variant='outlined'
// //                   size='small'
// //                   type='number'
// //                   value={boxes[size]}
// //                   onChange={(e) => handleChange(size, e.target.value)}
// //                 />
// //               </Box>
// //             ))} */}
// //           <Box display='flex' justifyContent='space-between' sx={{ mt: 3 }}>
// //             <Button variant='contained' color='primary' onClick={handleSubmit}>
// //               Submit
// //             </Button>
// //             <Button
// //               variant='outlined'
// //               color='secondary'
// //               onClick={handleDiscard}
// //             >
// //               Discard
// //             </Button>
// //           </Box>
// //         </Box>
// //       </Paper>
// //     </Container>
// //   );
// // };

// // export default AllotedItemForm;

// import React, { useEffect, useState } from 'react';
// import _, { isEmpty, map } from 'lodash';
// import {
//   Box,
//   TextField,
//   Typography,
//   List,
//   ListItem,
//   Select,
//   MenuItem,
//   Button,
//   Paper,
// } from '@mui/material';
// import departmentService from '../../services/departmentService';
// import itemService from '../../services/itemService';
// import LayoutContainer from '../../components/LayoutContainer';
// import AdminHeader from '../../components/AdminHeader';
// import itemDeliveryService from '../../services/itemDeliveryService';
// import { toast } from 'react-toastify';

// const AllotedItemForm = () => {
//   const [departments, setDepartments] = useState([]);
//   const [selectedDepartment, setSelectedDepartment] = useState('');
//   const [items, setItems] = useState([]);
//   const [allocations, setAllocations] = useState([]);

//   const fetchDepartment = async () => {
//     const response = await departmentService.getDepartments();
//     setDepartments(response.data);
//   };

//   const fetchItem = async () => {
//     const response = await itemService?.getItems();
//     setItems(response.data);
//   };

//   useEffect(() => {
//     fetchDepartment();
//     fetchItem();
//   }, []);

//   const handleInputChange = (id, value) => {
//     const quantity = parseInt(value, 10);

//     if (quantity > 0) {
//       const newAllocation = {
//         user_id: 1,
//         item_id: id,
//         allocated_qty: quantity,
//         delivered_qty: 0,
//         photo: '',
//         department_id: selectedDepartment,
//         event_id: 1,
//       };

//       const existingIndex = _.findIndex(allocations, { item_id: id });

//       if (existingIndex >= 0) {
//         const updatedAllocations = [...allocations];
//         updatedAllocations[existingIndex] = newAllocation;
//         setAllocations(updatedAllocations);
//       } else {
//         setAllocations([...allocations, newAllocation]);
//       }
//     } else {
//       const updatedAllocations = allocations.filter(
//         (allocation) => allocation.item_id !== id
//       );
//       setAllocations(updatedAllocations);
//     }
//   };

//   const handleSubmit = async () => {
//     const response = await itemDeliveryService?.createItemDelivery(allocations);
//     if (response?.status === 200) {
//       toast?.success('Department assign successfully');
//     }
//   };

//   return (
//     <LayoutContainer>
//       <AdminHeader title='Alloted Item' />
//       <div className='page-content-wrapper scrollable'>
//         <Box sx={{ backgroundColor: '#f5f5f5' }}>
//           <Paper elevation={2} sx={{ padding: 2, borderRadius: 2 }}>
//             <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
//               <Box>
//                 <Typography variant='body1' sx={{ fontWeight: 'bold' }}>
//                   Select Department
//                 </Typography>
//                 <Select
//                   fullWidth
//                   variant='outlined'
//                   value={selectedDepartment}
//                   onChange={(e) => setSelectedDepartment(e?.target?.value)}
//                 >
//                   {!isEmpty(departments) ? (
//                     map(departments, (option) => (
//                       <MenuItem key={option?.id} value={option?.id}>
//                         {option?.name}
//                       </MenuItem>
//                     ))
//                   ) : (
//                     <MenuItem disabled>No data found</MenuItem>
//                   )}
//                 </Select>
//                 {!selectedDepartment && (
//                   <Typography variant='caption' sx={{ color: 'red' }}>
//                     Department is required
//                   </Typography>
//                 )}
//               </Box>
//               {selectedDepartment && (
//                 <>
//                   <Typography
//                     display='flex'
//                     justifyContent='flex-end'
//                     marginTop={1}
//                     paddingRight={9}
//                     fontWeight={500}
//                   >
//                     Alloted qty(Boxes)
//                   </Typography>
//                   <List>
//                     {items.map((item) => (
//                       <ListItem
//                         key={item.id}
//                         sx={{
//                           display: 'flex',
//                           justifyContent: 'space-between',
//                           alignItems: 'center',
//                           padding: 1,
//                         }}
//                       >
//                         <Typography variant='body1'>
//                           {item.item_name}
//                         </Typography>
//                         <TextField
//                           type='number'
//                           inputProps={{ min: 0 }}
//                           onChange={(e) =>
//                             handleInputChange(item.id, e.target.value)
//                           }
//                           variant='outlined'
//                           size='small'
//                         />
//                       </ListItem>
//                     ))}
//                   </List>
//                 </>
//               )}

//               {selectedDepartment && (
//                 <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
//                   <Button
//                     variant='contained'
//                     color='primary'
//                     disabled={isEmpty(allocations)}
//                     onClick={handleSubmit}
//                   >
//                     Submit
//                   </Button>
//                 </Box>
//               )}
//               {/* <Typography variant='h5' sx={{ marginTop: 3 }}>
//                 Allocations
//               </Typography>
//               <Box
//                 sx={{
//                   backgroundColor: '#eef',
//                   padding: 2,
//                   borderRadius: 1,
//                   overflowX: 'auto',
//                   whiteSpace: 'pre-wrap',
//                   marginTop: 1,
//                 }}
//               >
//                 <pre>{JSON.stringify(allocations, null, 2)}</pre>
//               </Box> */}
//             </Box>
//           </Paper>
//         </Box>
//       </div>
//     </LayoutContainer>
//   );
// };

// export default AllotedItemForm;

import React, { useEffect, useState } from 'react';
import {
  Box,
  Paper,
  Typography,
  Select,
  MenuItem,
  Button,
  TextField,
  List,
  ListItem,
  FormHelperText,
  FormControl,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  createTheme,
  ThemeProvider,
} from '@mui/material';
import {
  concat,
  filter,
  flatMap,
  groupBy,
  includes,
  isEmpty,
  isEqual,
  lowerCase,
  map,
  mapValues,
  omit,
  upperFirst,
  zipObject,
} from 'lodash';
import departmentService from '../../services/departmentService';
import itemService from '../../services/itemService';
import itemDeliveryService from '../../services/itemDeliveryService';
import { toast } from 'react-toastify';
import AdminHeader from '../../components/AdminHeader';
import eventService from '../../services/eventService';
import allotedItemsService from '../../services/allotedItemsService';
import { FaFileCsv } from 'react-icons/fa6';
import * as XLSX from 'xlsx';
import axios from 'axios';
import EditIcon from '@mui/icons-material/Edit';
import { Field, Form, Formik } from 'formik';
import { useNavigate } from 'react-router-dom';
import MUIDataTable from 'mui-datatables';
import DeleteModal from '../../components/DeleteModal';

const AllotedItemForm = () => {
  const [departments, setDepartments] = useState([]);
  const roles = JSON.parse(localStorage?.getItem('roles'));
  const [selectedDepartment, setSelectedDepartment] = useState('');
  const [items, setItems] = useState([]);
  const [stationType, setStationType] = useState('ROUTE');
  const navigate = useNavigate();
  const [file, setFile] = useState(null);
  const [deliveryItems, setDeliveryItems] = useState([]); // Fetched delivery items
  const [updatedAllocations, setUpdatedAllocations] = useState([]); // User input state
  const [openModal, setOpenModal] = useState(false); // Modal visibility state
  const [selectedItem, setSelectedItem] = useState(null); // Store the item to be edited
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  // const fetchDepartment = async () => {
  //   const response = await departmentService.getDepartments();
  //   setDepartments(response.data);
  // };

  const fetchDepartment = async () => {
    const res = await eventService?.getEventDetail();
    if (res?.status === 200) {
      setDepartments(
        filter(res?.data, {
          event_id: parseInt(localStorage?.getItem('event_id')),
        })
      );
    }
  };

  const fetchItem = async () => {
    try {
      const response = await itemService.getItemsByEventId();
      setItems(response.data);
    } catch (e) {
      toast.error(e?.response?.data?.message);
    }
  };

  const fetchAllocations = async () => {
    const response = await itemDeliveryService.getItemDeliveries(
      localStorage?.getItem('event_id')
    );
    setDeliveryItems(
      groupBy(
        map(response.data, (data) => {
          return {
            ...data,
            allocated_qty:
              data?.event_id === parseInt(localStorage?.getItem('event_id'))
                ? data?.allocated_qty
                : '',
          };
        }),
        'station'
      )
    );
  };

  useEffect(() => {
    // fetchDepartment();
    fetchItem();
  }, []);

  useEffect(() => {
    fetchAllocations();
    setUpdatedAllocations([]);
  }, []);

  const handleInputChange = (id, value) => {
    const quantity = parseInt(value, 10); // Allow empty input to set qty to 0

    setUpdatedAllocations((prev) => {
      const existingIndex = prev.findIndex(
        (allocation) =>
          allocation.item_id === id &&
          allocation.department_id === selectedDepartment
      );

      const newAllocation = {
        user_id: localStorage?.getItem('user_id'),
        item_id: id,
        allocated_qty: quantity,
        delivered_qty: 0,
        picked_qty: 0,
        photo: '',
        department_id: selectedDepartment,
        event_id: 1,
      };

      if (existingIndex >= 0) {
        // Update existing allocation
        const updated = [...prev];
        updated[existingIndex] = newAllocation;
        return updated;
      } else {
        // Add new allocation
        return [...prev, newAllocation];
      }
    });
  };

  // const handleSubmit = async () => {
  //   const existingAllocations = [];
  //   const newAllocations = [];

  //   updatedAllocations.forEach((allocation) => {
  //     const existingAllocation = deliveryItems.find(
  //       (item) =>
  //         item.item_id === allocation.item_id &&
  //         item.department_id === allocation.department_id &&
  //         item?.event_id === parseInt(localStorage?.getItem('event_id'))
  //     );

  //     const itemId = deliveryItems.find(
  //       (item) =>
  //         item.item_id === allocation.item_id &&
  //         item.department_id === allocation.department_id
  //     )?.id;

  //     if (existingAllocation?.id) {
  //       existingAllocations.push({ ...allocation, id: itemId });
  //     } else {
  //       newAllocations.push(allocation);
  //     }
  //   });

  //   try {
  //     // Update existing allocations if there are any
  //     if (existingAllocations.length > 0) {
  //       await itemDeliveryService.updateItemDelivery(
  //         1,
  //         map(existingAllocations, (data) => {
  //           return {
  //             ...data,
  //             event_id: parseInt(localStorage?.getItem('event_id')),
  //           };
  //         })
  //       );
  //     }

  //     // Create new allocations if there are any
  //     if (newAllocations.length > 0) {
  //       await itemDeliveryService.createItemDelivery(
  //         map(newAllocations, (data) => {
  //           return {
  //             ...data,
  //             event_id: parseInt(localStorage?.getItem('event_id')),
  //           };
  //         })
  //       );
  //     }

  //     toast.success('Allocations processed successfully');
  //     navigate('/alloted-items');
  //     fetchAllocations(); // Refresh the allocations
  //     setUpdatedAllocations([]); // Clear updated allocations state
  //   } catch (error) {
  //     toast.error('Failed to process allocations');
  //   }
  // };

  // const downloadExcel = (data) => {
  //   const headers = ['Station', 'Product Name', 'Quantity'];
  //   const dataToExport = data.map((item) => [
  //     item.department,
  //     item.product,
  //     item.quantity,
  //   ]);

  //   const ws = XLSX.utils.aoa_to_sheet([headers, ...dataToExport]);

  //   const wb = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

  //   XLSX.writeFile(wb, 'product_data.csv');
  // };

  // const convertCsvToArrayOfObjects = (csv) => {
  //   const [headers, ...rows] = csv
  //     .trim()
  //     .split('\n')
  //     .map((row) => row.split(','));

  //   downloadExcel(
  //     rows.map((row) => ({
  //       department: row[0],
  //       product: row[1],
  //       quantity: parseInt(row[2]),
  //     }))
  //   );
  // };

  const handleDownloadSample = async () => {
    // const res = await allotedItemsService?.downloadBulkAllotedItemFile(
    //   localStorage?.getItem('event_id')
    // );
    // if (res?.status === 200) {
    //   convertCsvToArrayOfObjects(res?.data);

    const headers = concat(
      `${stationType} STATION`,
      map(filter(items, { station_type: stationType }), 'item_name')
    );

    const ws = XLSX.utils.aoa_to_sheet([headers]);

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    XLSX.writeFile(wb, 'product_data.csv');
  };
  // };

  const handleFileUpload = async (e) => {
    const uploadedFile = e.target.files[0];
    if (uploadedFile) {
      setFile(uploadedFile);
      const formData = new FormData();

      const bodyData = {
        event_id: parseInt(localStorage?.getItem('event_id')),
        user_id: parseInt(localStorage?.getItem('user_id')),
        station_type: stationType,
      };

      formData.append('event_id', bodyData?.event_id);
      formData.append('user_id', bodyData?.user_id);
      formData.append('station_type', bodyData?.station_type);
      formData.append('file', uploadedFile);

      try {
        // const response = allotedItemsService?.uplodaBulkAllotedItem(formData);
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/products/upload-item-delivery`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }
        );

        if (response?.status === 200) {
          fetchAllocations();
          toast?.success('CSV data uploaded successfully');
        }
      } catch (err) {
        toast.error(err?.response?.data?.error);
        console.log('err:', err);
      } finally {
        setFile(null);
      }
    } else {
      toast?.error('Please upload excel file!!', 'error');
    }
    e.target.value = '';
  };

  const handleOpenModal = (item) => {
    setSelectedItem(item);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedItem(null);
  };

  console.log("selectedItem",selectedItem);
  
  const handleSubmit = async (values) => {
    try {
      const res = await itemDeliveryService.updateItemDeliveryAllotedQty(
        selectedItem?.id,
        omit(
          {
            ...values,
            event_id: parseInt(localStorage?.getItem('event_id')),
            remarks: 'allotted',
            // station: selectedItem?.station,
            station_type: selectedItem?.station_type,
            user_id: parseInt(localStorage?.getItem('user_id')),
          },
          ['delivered_date', 'item_name', 'station']
        )
      );
      if (res?.status === 200) {
        fetchAllocations();
        handleCloseModal();
        toast?.success('Quantity updated successfully');
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
      // console.log('error',error?.response?.data?.message)
    }
  };

  const data = Object.entries(
    mapValues(deliveryItems, (stations) =>
      stations.filter((station) => station.station_type === stationType)
    )
  ).flatMap(([station, items]) =>
    items.map((item) => ({
      station,
      station_type: item.station_type || '-',
      item_name: item.item_name || '-',
      allocated_qty: item.allocated_qty || 0,
      delivered_qty: item.delivered_qty || 0,
      picked_qty: item.picked_qty || 0,
      action: (
        <IconButton onClick={() => handleOpenModal(item)}>
          <EditIcon sx={{ color: '#be210b' }} />
        </IconButton>
      ),
    }))
  );

  const options = {
    expandableRows: false,
    // download: false,
    filterOptions: 'fullWidth',
    selectableRows: 'none',
    print: false,
    rowsPerPageOptions: [30, 50, 100],
    rowsPerPage: 30,
    viewColumns: false,
    downloadOptions: {
      filterOptions: {
        useDisplayedColumnsOnly: true,
        useDisplayedRowsOnly: true,
      },
    },
  };

  const getMuiTheme = () =>
    createTheme({
      components: {
        MUIDataTable: {
          styleOverrides: {
            root: {
              boxShadow: 'none',
              backgroundColor: '#FFF',
            },
          },
        },
        MUIDataTableHeadCell: {
          styleOverrides: {
            root: {
              backgroundColor: '#2F3542', // Keep background as you have it
              color: '#fff !important', // Ensure heading text is white
              border: 'none',
              fontWeight: '550 !important',
              '&:nth-last-of-type(1)': {
                borderTopRightRadius: '1rem',
                // borderBottomRightRadius: '0.2rem',
              },
            },
            sortActive: {
              color: '#fff !important', // Active sort icon color should also be white
            },
            sortAction: {
              '& .MuiTableSortLabel-icon': {
                color: '#fff !important', // Ensure sort icon stays white when active
              },
            },
            toolButton: {
              fontWeight: 'bold',
              fontSize: '0.7rem',
              paddingTop: '3px',
              paddingBottom: '3px',
            },
          },
        },
        MuiIconButton: {
          styleOverrides: {
            root: {
              padding: '2px 8px 2px 8px',
            },
          },
        },
        MuiTablePagination: {
          styleOverrides: {
            root: {
              backgroundColor: '#FFFFFF',
              height: '40px',
            },
            select: {
              backgroundColor: '#FFFFFF',
            },
            actions: {
              backgroundColor: '#FFFFFF',
            },
          },
        },
        MUIDataTableSelectCell: {
          styleOverrides: {
            headerCell: {
              border: 'none',
              borderTopLeftRadius: '0.2rem',
              borderBottomLeftRadius: '0.2rem',
              backgroundColor: '#2F3542',
              '& .MuiCheckbox-root': {
                color: '#fff',
                padding: '4px',
              },
            },
          },
        },
        MuiToolbar: {
          styleOverrides: {
            root: {
              minHeight: '30px!important',
              padding: '0px!important',
            },
          },
        },
        MuiCheckbox: {
          styleOverrides: {
            root: {
              padding: '4px',
            },
          },
        },
        MUIDataTableBodyRow: {
          styleOverrides: {
            root: {
              '&:nth-of-type(even)': {
                backgroundColor: '#EAF3FF',
              },
              '&:nth-of-type(odd)': {
                backgroundColor: '#FFF',
              },
              '& td': {
                textAlign: 'left', // Center align body text data
                border: 'none',
              },
              marginBottom: '10px',
            },
          },
        },
        MuiButton: {
          styleOverrides: {
            root: {
              color: '#fff',
              padding: '6px 0px !important',
              fontWeight: '550 !important',
              fontSize: '0.8rem !important',
              justifyContent: 'start',
            },
          },
        },
        MuiTableCell: {
          styleOverrides: {
            root: {
              padding: '2px 26px !important',
              fontSize: '0.675rem',
            },
          },
        },
        MUIDataTableBodyCell: {
          styleOverrides: {
            root: {
              fontSize: '0.675rem !important',
            },
          },
        },
        MuiPopover: {
          styleOverrides: {
            paper: {
              minWidth: '500px !important', // Increase the width of filter dropdown
              padding: '10px', // Add padding inside the dropdown
              borderRadius: '8px', // Optionally, round the corners
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)', // Add a subtle shadow for better visibility
              backgroundColor: '#fff', // Background color (you can change it)
            },
          },
        },
        MuiMenu: {
          styleOverrides: {
            paper: {
              minWidth: '200px  !important',
              maxHeight: '200px',
              overflowY: 'auto',
            },
          },
        },
        MuiMenuItem: {
          styleOverrides: {
            root: {
              fontSize: '0.675rem !important',
              fontWeight: 500,
              color: '#333',
              padding: '8px 16px',
              '&:hover': {
                backgroundColor: '#F5F5F5',
              },
            },
          },
        },
        MuiSelect: {
          styleOverrides: {
            select: {
              fontSize: '0.675rem !important',
              padding: '6px 10px',
            },
          },
        },
      },
    });

  const columns = [
    {
      name: 'station',
      label: 'NAME',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'station_type',
      label: 'TYPE',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'item_name',
      label: 'PRODUCT',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'allocated_qty',
      label: 'ALLOCATED QTY',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'delivered_qty',
      label: 'DELIVERED QTY',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'picked_qty',
      label: 'PICKED QTY',
      options: {
        filter: true,
        sort: true,
      },
    },
    // {
    //   name: 'allocated_qty',
    //   label: 'ALLOCATED QTY',
    //   options: {
    //     filter: true,
    //     sort: true,
    //     align: 'right', // Cell content alignment
    //     headerAlign: 'right', // Header content alignment
    //     customHeadRender: (columnMeta, updateDirection) => {
    //       return (
    //         <div
    //           style={{
    //             display: 'flex',
    //             backgroundColor: '#2F3542',
    //             color: '#FFF',
    //             padding: '9.8px 0px',
    //             fontWeight: 500,
    //             justifyContent: 'center', // Align header to the right
    //             width: '100%', // Ensure it takes up the full width
    //           }}
    //         >
    //           {columnMeta.label}
    //         </div>
    //       );
    //     },
    //     customBodyRender: (value) => {
    //       return (
    //         <div style={{ textAlign: 'right', paddingRight: '1.2rem' }}>
    //           {value}
    //         </div>
    //       ); // Right-align cell content
    //     },
    //   },
    // },
    // {
    //   name: 'delivered_qty',
    //   label: 'DELIVERED QTY',
    //   options: {
    //     filter: true,
    //     sort: true,
    //     align: 'right', // Cell content alignment
    //     headerAlign: 'right', // Header content alignment
    //     customHeadRender: (columnMeta, updateDirection) => {
    //       return (
    //         <div
    //           style={{
    //             display: 'flex',
    //             backgroundColor: '#2F3542',
    //             color: '#FFF',
    //             padding: '9.8px 0px',
    //             fontWeight: 500,
    //             justifyContent: 'center', // Align header to the right
    //             width: '100%', // Ensure it takes up the full width
    //           }}
    //         >
    //           {columnMeta.label}
    //         </div>
    //       );
    //     },
    //     customBodyRender: (value) => {
    //       return (
    //         <div style={{ textAlign: 'right', paddingRight: '1.2rem' }}>
    //           {value}
    //         </div>
    //       ); // Right-align cell content
    //     },
    //   },
    // },
    // {
    //   name: 'picked_qty',
    //   label: 'PICKED QTY',
    //   options: {
    //     filter: true,
    //     sort: true,
    //     align: 'right', // Cell content alignment
    //     headerAlign: 'right', // Header content alignment
    //     customHeadRender: (columnMeta, updateDirection) => {
    //       return (
    //         <div
    //           style={{
    //             display: 'flex',
    //             backgroundColor: '#2F3542',
    //             color: '#FFF',
    //             padding: '9.8px 0px',
    //             fontWeight: 500,
    //             justifyContent: 'center', // Align header to the right
    //             width: '100%', // Ensure it takes up the full width
    //           }}
    //         >
    //           {columnMeta.label}
    //         </div>
    //       );
    //     },
    //     customBodyRender: (value) => {
    //       return (
    //         <div style={{ textAlign: 'right', paddingRight: '1.2rem' }}>
    //           {value}
    //         </div>
    //       ); // Right-align cell content
    //     },
    //   },
    // },
    // {
    //   name: 'allocated_qty',
    //   label: 'ALLOCATED QTY',
    //   options: {
    //     filter: true,
    //     sort: true,
    //     headerAlign: 'right',  // Align header text to the right
    //     align: 'right',        // Align cell content to the right
    //   },
    // },
    {
      name: 'action',
      label: 'ACTION',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value) => value,
      },
    },
  ];

  const handleDelete = async () => {
    try {
      const res = await itemService.deleteProductList({
        table_name: 'item_delivery',
        ids: map(
          filter(flatMap(deliveryItems), { station_type: stationType }),
          'id'
        ),
      });

      if (res?.status === 204) {
        toast.success('Alloted items removed successfully');
        fetchAllocations();
      }
    } catch (e) {
      toast.error(e?.response?.data?.message || 'Something went wrong');
    } finally {
      setOpenDeleteModal(false);
    }
  };

  // const handleDelete = async () => {
  //   const confirmDelete = window.confirm(
  //     `Are you sure you want to clear the data?`
  //   );
  //   if (confirmDelete) {
  //     try {
  //       const res = await itemService.deleteProductList({
  //         table_name: 'item_delivery',
  //         ids: map(
  //           filter(flatMap(deliveryItems), { station_type: stationType }),
  //           'id'
  //         ),
  //         // ids: filter(
  //         //   flatMap(deliveryItems),
  //         //   { station_type: stationType },
  //         //   (stationItems) => map(stationItems, 'id')
  //         // ),
  //       });

  //       if (res?.status === 204) {
  //         toast.success('Alloted items removed successfully');
  //         fetchAllocations();
  //       }
  //     } catch (e) {
  //       toast.error(e?.response?.data?.message);
  //     }
  //   } else {
  //     return false;
  //   }
  // };

  return (
    <>
      <AdminHeader title='ALLOTED QTY' />
      <div className='page-content-wrapper scrollable'>
        {/* <Paper elevation={2} sx={{ padding: 2, borderRadius: 2, m: 1 }}>
          <Box component='form'>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
              <Typography variant='body1' sx={{ fontWeight: 'bold' }}>
                Select Station
              </Typography>
              <Select
                name='department_id'
                sx={{ mb: 1 }}
                fullWidth
                variant='outlined'
                value={selectedDepartment}
                onChange={(e) => setSelectedDepartment(e.target.value)}
              >
                {!isEmpty(departments) ? (
                  map(departments, (option) => (
                    <MenuItem
                      key={option.department_id}
                      value={option.department_id}
                    >
                      {option.department_name}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>No data found</MenuItem>
                )}
              </Select>
              {!selectedDepartment && (
                <Typography
                  variant='caption'
                  sx={{ color: 'red', fontSize: '0.7rem' }}
                >
                  Station is required
                </Typography>
              )}
            </Box>

            {selectedDepartment && (
              <>
                <Typography
                  display='flex'
                  justifyContent='flex-end'
                  marginTop={1}
                  paddingRight={9}
                  fontWeight={500}
                >
                  Allocated qty
                </Typography>
                <List>
                  {items.map((item) => {
                    const existingAllocation = deliveryItems.find(
                      (allocation) =>
                        allocation.item_id === item.id &&
                        allocation.department_id === selectedDepartment &&
                        allocation?.event_id ===
                          parseInt(localStorage?.getItem('event_id'))
                    );

                    const currentQuantity = existingAllocation
                      ? existingAllocation.allocated_qty
                      : '';

                    const updatedAllocation = updatedAllocations.find(
                      (allocation) =>
                        allocation.item_id === item.id &&
                        allocation.department_id === selectedDepartment
                    );

                    // Use the updated allocation if available; otherwise, use the current quantity (unless the user cleared it)
                    const updatedQuantity =
                      updatedAllocation?.allocated_qty !== undefined
                        ? updatedAllocation.allocated_qty
                        : currentQuantity;

                    return (
                      <ListItem
                        key={item.id}
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          padding: 1,
                        }}
                      >
                        <Typography variant='body1'>
                          {item.item_name}
                        </Typography>
                        <Box sx={{ display: 'flex', gap: 2 }}>
                          <TextField
                            type='number'
                            value={
                              updatedQuantity !== undefined
                                ? updatedQuantity
                                : ''
                            }
                            onChange={(e) =>
                              handleInputChange(item.id, e.target.value)
                            }
                            variant='outlined'
                            size='small'
                            inputProps={{ min: 0 }}
                            // helperText={
                            //   updatedQuantity <= 0
                            //     ? 'Please enter a value greater than 0'
                            //     : ''
                            // }
                            // error={updatedQuantity <= 0}
                          />
                        </Box>
                      </ListItem>
                    );
                  })}
                </List>
              </>
            )}

            {selectedDepartment && (
              <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                  variant='contained'
                  color='primary'
                  disabled={isEmpty(updatedAllocations)}
                  onClick={handleSubmit}
                >
                  Submit
                </Button>
              </Box>
            )}
          </Box>
        </Paper> */}
        <Paper elevation={2} sx={{ padding: 2, borderRadius: 2, m: 1 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            {(isEqual(roles, ['SUPER ADMIN']) ||
              isEqual(roles, ['ADMIN', 'SUPER ADMIN'])) && (
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <Typography variant='body1' sx={{ fontWeight: 'bold' }}>
                  BULK UPLOAD
                </Typography>
              </Box>
            )}
            <Box>
              <Typography variant='body2' sx={{ fontWeight: 600 }}>
                STATION TYPE <span style={{ color: 'red' }}>*</span>
              </Typography>
              <FormControl fullWidth>
                <Select
                  labelId='station-type-label'
                  name='stationType'
                  value={stationType}
                  onChange={(e) => {
                    const type = e?.target?.value;
                    setStationType(type);
                  }}
                  sx={{
                    backgroundColor: '#f5f5f5',
                    borderRadius: 1,
                  }}
                >
                  {['ROUTE', 'JUNCTION'].map((type) => (
                    <MenuItem key={type} value={type}>
                      {type}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>
                  {isEmpty(stationType) && (
                    <span style={{ color: 'red' }}>
                      Station type is required
                    </span>
                  )}
                </FormHelperText>
              </FormControl>
            </Box>
            {(isEqual(roles, ['SUPER ADMIN']) ||
              isEqual(roles, ['ADMIN', 'SUPER ADMIN'])) &&
              !isEmpty(stationType) && (
                <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'center' }}>
                  <input
                    type='file'
                    onChange={handleFileUpload}
                    style={{
                      fontSize: '0.675rem',
                      padding: '8px 12px',
                      border: '1px solid #ddd',
                      borderRadius: '4px',
                      outline: 'none',
                      // width: '60%',
                    }}
                  />
                  {file && (
                    <span style={{ color: '#0088ff' }}>{file?.name}</span>
                  )}
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      cursor: 'pointer',
                      gap: 0.6,
                      color: '#BE1E2E',
                    }}
                    onClick={handleDownloadSample}
                  >
                    <FaFileCsv size={22} fill='green' />
                    <Typography
                      variant='body2'
                      fontWeight={550}
                      color={'green'}
                    >
                      DOWNLOAD FILE
                    </Typography>
                  </Box>
                </Box>
              )}
          </Box>
        </Paper>

        {/* {(isEqual(roles, ['SUPER ADMIN']) ||
          (isEqual(roles, ['ADMIN', 'SUPER ADMIN']) &&
            !isEmpty(deliveryItems))) && (
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
            <Button
              variant='outline'
              sx={{
                border: '1px solid #e30909',
                color: '#e30909',
                padding: '2px 16px !important',
              }}
              onClick={handleDelete}
            >
              Clear All
            </Button>
          </Box>
        )} */}

        <Paper elevation={2} sx={{ padding: 2, borderRadius: 2, mx: 1, mt: 2 }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              mb: 1,
            }}
          >
            <Typography variant='body1' sx={{ fontWeight: 'bold' }}>
              ALLOTED ITEMS LIST
            </Typography>
            {(isEqual(roles, ['SUPER ADMIN']) ||
              isEqual(roles, ['ADMIN', 'SUPER ADMIN'])) &&
              !isEmpty(deliveryItems) &&
              !isEmpty(
                filter(flatMap(deliveryItems), { station_type: stationType })
              ) && (
                <Button
                  variant='outline'
                  sx={{
                    border: '1px solid #e30909',
                    color: '#e30909',
                    padding: '2px 16px !important',
                  }}
                  onClick={() => setOpenDeleteModal(true)}
                >
                  Clear All
                </Button>
              )}
          </Box>
          {/* <Table className='table'>
            <TableHead className='tableHead'>
              <TableRow>
                <TableCell>Station</TableCell>
                <TableCell>Station Type</TableCell>
                <TableCell>Product</TableCell>
                <TableCell>Allocated Qty</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            {!isEmpty(deliveryItems) ? (
              <TableBody >
                {Object.entries(deliveryItems)?.map(([station, items]) => (
                  <>
                    <TableRow
                      key={station}
                      style={{ backgroundColor: '#f5f5f5', fontWeight: 'bold' }}
                    >
                      <TableCell
                        colSpan={7}
                        style={{
                          textAlign: 'left',
                          padding: '12px 15px',
                          border: '1px solid #ddd',
                          fontWeight: 600,p:4,
                        }}
                      >
                        {station}
                      </TableCell>
                    </TableRow>
                    {items?.map((item, index) => (
                      <TableRow
                        key={item.id}
                        sx={{
                          backgroundColor: index % 2 === 0 ? '#fff' : '#eaf3ff',
                        }}
                      >
                        <TableCell>{item.station}</TableCell>
                        <TableCell>{item.station_type || '-'}</TableCell>
                        <TableCell>{item.item_name || '-'}</TableCell>
                        <TableCell>{item.allocated_qty || '-'}</TableCell>
                        <TableCell>
                          <IconButton onClick={() => handleOpenModal(item)}>
                            <EditIcon sx={{ color: '#be210b' }} />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </>
                ))}
              </TableBody>
            ) : (
              <TableBody>
                <TableRow>
                  <TableCell
                    colSpan={5}
                    sx={{ textAlign: 'center', padding: '16px' }}
                  >
                    <Typography
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        width: '100%',
                      }}
                    >
                      No data found
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableBody>
            )}
          </Table> */}
          <ThemeProvider theme={getMuiTheme()}>
            <MUIDataTable
              // title={'Delivery Items'}
              data={data}
              columns={columns}
              options={options}
            />
          </ThemeProvider>
          {/* Modal for Editing */}
          <Dialog open={openModal} onClose={handleCloseModal}>
            <DialogTitle>EDIT ITEM</DialogTitle>
            <DialogContent sx={{ minWidth: '500px' }}>
              {selectedItem && (
                <Formik
                  initialValues={{
                    ...selectedItem,
                    item_name: selectedItem.item_name,
                    allocated_qty: selectedItem.allocated_qty || 0,
                    delivered_qty: selectedItem.delivered_qty || 0,
                    picked_qty: selectedItem.picked_qty || 0,
                  }}
                  onSubmit={handleSubmit}
                >
                  {({ values, handleChange, handleBlur }) => (
                    <Form>
                      <Typography
                        sx={{
                          mb: 0,
                          mt: 1.5,
                          fontSize: '0.8rem',
                          fontWeight: 600,
                        }}
                      >
                        ITEM
                      </Typography>
                      <Field
                        name='item_name'
                        as={TextField}
                        placeholder='Product'
                        value={values.item_name}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                        disabled
                      />
                      <Typography
                        sx={{
                          mb: 0,
                          mt: 1.5,
                          fontSize: '0.8rem',
                          fontWeight: 600,
                        }}
                      >
                        ALLOCATED QTY
                      </Typography>
                      <Field
                        name='allocated_qty'
                        as={TextField}
                        placeholder='Quantity'
                        type='number'
                        value={values.allocated_qty}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                      />
                      <Typography
                        sx={{
                          mb: 0,
                          mt: 1.5,
                          fontSize: '0.8rem',
                          fontWeight: 600,
                        }}
                      >
                        DELIVERED QTY
                      </Typography>
                      <Field
                        name='delivered_qty'
                        as={TextField}
                        placeholder='Quantity'
                        type='number'
                        value={values.delivered_qty}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                      />
                      <Typography
                        sx={{
                          mb: 0,
                          mt: 1.5,
                          fontSize: '0.8rem',
                          fontWeight: 600,
                        }}
                      >
                        PICKED QTY
                      </Typography>
                      <Field
                        name='picked_qty'
                        as={TextField}
                        placeholder='Quantity'
                        type='number'
                        value={values.picked_qty}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                      />
                      <DialogActions>
                        <Button
                          onClick={handleCloseModal}
                          color='error'
                          variant='contained'
                        >
                          Cancel
                        </Button>
                        <Button
                          type='submit'
                          color='primary'
                          variant='contained'
                        >
                          Save
                        </Button>
                      </DialogActions>
                    </Form>
                  )}
                </Formik>
              )}
            </DialogContent>
          </Dialog>
        </Paper>
        <DeleteModal
          open={openDeleteModal}
          handleDailogClose={() => setOpenDeleteModal(false)}
          handleDelete={handleDelete}
        />
      </div>
    </>
  );
};

export default AllotedItemForm;
